export const FLEET_SEQUENCE_COLUMN_PREFERENCE_KEY = "fleet_sequence_route";

export const FLEET_SEQUENCE_COLUMN_KEYS = Object.freeze([
  "step",
  "route",
  "silo",
  "order",
  "workOrder",
  "product",
  "code",
  "compartment",
  "occupancy",
  "fillRate",
  "tonnage",
  "charge",
  "distance",
  "service",
  "meunerie",
  "aspirator",
  "buffer",
  "travel",
]);

export function buildFleetSequencePreferenceColumns({
  defaultWidths = {},
  labels = {},
  minWidths = {},
} = {}) {
  return FLEET_SEQUENCE_COLUMN_KEYS.map((key) => ({
    key,
    label: typeof labels[key] === "string" && labels[key].trim() ? labels[key].trim() : key,
    defaultWidth: Number.isFinite(Number(defaultWidths[key])) ? Number(defaultWidths[key]) : 100,
    minWidth: Number.isFinite(Number(minWidths[key])) ? Number(minWidths[key]) : 48,
  }));
}
